import {
  DefaultButton,
  mergeStyles,
  Modal,
  Stack,
  useTheme,
} from '@fluentui/react';
import React from 'react';
import Signature from 'react-signature-canvas';
import { ButtonGroup, Input } from '..';

export interface SignatureCanvasProps {
  onSubmit?: (input: Input[]) => Promise<void>;
}

export const SignatureCanvas = (props: SignatureCanvasProps): JSX.Element => {
  const { onSubmit } = props;
  const theme = useTheme();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const canvasRef = React.useRef<Signature>(null);
  const width = Math.min(window.innerWidth, window.outerWidth) - 64;

  const clearCanvas = () => {
    canvasRef.current?.clear();
    canvasRef.current?.off();
    canvasRef.current?.on();
  };

  const getImage = () => {
    const imageDataUrl = canvasRef.current
      ?.getTrimmedCanvas()
      .toDataURL('image/png');
    return imageDataUrl;
  };

  const handleOnSubmit = () => {
    const imageDataUrl = getImage();
    const input = [
      {
        id: 'signature',
        key: 'signature',
        name: 'signature',
        value: imageDataUrl || '',
      },
    ];
    setIsModalOpen(false);
    !canvasRef.current?.isEmpty() && onSubmit && onSubmit(input);
  };

  const onSubmitSignatureCanvasButton = () => {
    setIsModalOpen(true);
  };

  if (!isModalOpen) {
    return <SignatureCanvasButton onSubmit={onSubmitSignatureCanvasButton} />;
  }

  return (
    <Modal
      isOpen={isModalOpen}
      isBlocking={false}
      isModeless={false}
      allowTouchBodyScroll={true}
      onDismiss={() => setIsModalOpen(false)}
      styles={{ main: { borderRadius: theme.effects.roundedCorner6 } }}
    >
      <div
        className={mergeStyles({
          padding: '1rem',
          boxShadow: theme.effects.elevation8,
          width: width,
          borderRadius: theme.effects.roundedCorner6,
          background: theme.palette.neutralPrimary,
        })}
      >
        <Stack>
          <p
            className={mergeStyles({
              padding: 0,
              margin: 0,
              marginBottom: '1rem',
              color: theme.palette.white,
            })}
          >
            Sign Full Legal Name
          </p>
        </Stack>
        <Signature
          ref={canvasRef}
          canvasProps={{
            width: width,
            height: 200,
            className: mergeStyles({
              border: '1px dashed #AAA',
              marginBottom: '1rem',
              background: 'white',
              // boxShadow: theme.effects.elevation8,
            }),
          }}
        />
        <Stack horizontal horizontalAlign="space-between">
          <Stack>
            <DefaultButton
              className={mergeStyles({
                borderRadius: theme.effects.roundedCorner6,
                height: '48px',
                background: theme.palette.neutralPrimary,
                color: theme.palette.white,
              })}
              onClick={() => clearCanvas()}
            >
              Clear
            </DefaultButton>
          </Stack>
          <Stack>
            <DefaultButton
              className={mergeStyles({
                borderRadius: theme.effects.roundedCorner6,
                height: '48px',
                background: theme.palette.neutralPrimary,
                color: theme.palette.white,
              })}
              onClick={() => handleOnSubmit()}
            >
              Accept
            </DefaultButton>
          </Stack>
        </Stack>
      </div>
    </Modal>
  );
};

export interface SignatureCanvasButtonProps {
  imageDataUrl?: string;
  onSubmit?: () => void;
}

export const SignatureCanvasButton = (
  props: SignatureCanvasButtonProps
): JSX.Element => {
  const { onSubmit, imageDataUrl } = props;
  return (
    <Stack>
      {imageDataUrl && (
        <Stack>
          <img src={imageDataUrl} />
        </Stack>
      )}
      <Stack>
        <ButtonGroup
          underline={true}
          onSubmit={async () => onSubmit && onSubmit()}
          inputs={[
            {
              id: 'signature',
              key: 'signature',
              value: 'Provide Signature',
              name: 'Provide Signature',
            },
          ]}
        />
      </Stack>
    </Stack>
  );
};
